import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'
import React from 'react'
import { NumericFormat } from 'react-number-format'

import ServiceTypeAvatar from 'components/common/avatar/ServiceTypeAvatar'
import T from 'T'
import { DIVIDER } from 'theme/colors'
import { get } from 'utils/lodash'
import { getServiceRecurrenceText } from 'utils/service'

const ServicesList = ({ services }) => {
  if (!services || services.length === 0) {
    return (
      <Typography color="text.secondary" sx={{ p: 2 }} textAlign="center" variant="body2">
        {T.NO_SERVICES_FOUND_FOR_LOCATION}
      </Typography>
    )
  }

  return (
    <List dense sx={{ py: 0 }}>
      {services.map((service, index) => {
        const serviceName = get(service, 'serviceName', 'Unnamed Service')
        const price = get(service, 'servicePrice', 0)
        const recurrenceText = getServiceRecurrenceText(service)
        const serviceType = get(service, 'serviceType', '')

        return (
          <React.Fragment key={service.configuredServiceId || service.id || index}>
            <ListItem
              divider={index !== services.length - 1}
              sx={{
                p: 2,
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, maxWidth: '100%' }}>
                <Box alignItems="center" display="flex" gap={1}>
                  <Typography
                    fontWeight={600}
                    sx={{
                      color: 'text.primary',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      flex: 1,
                    }}
                    variant="h6"
                  >
                    {serviceName}
                  </Typography>
                  <Typography
                    fontWeight={600}
                    sx={{
                      color: 'text.primary',
                      flexShrink: 0,
                      borderLeft: `1px solid ${DIVIDER}`,
                      pl: 1.5,
                    }}
                    variant="h6"
                  >
                    <NumericFormat fixedDecimalScale thousandSeparator decimalScale={2} displayType="text" prefix="$" value={price} />
                  </Typography>
                </Box>
                <Box alignItems="center" display="flex" gap={1} mt={0.5}>
                  <Box
                    sx={{
                      borderRight: `1px solid ${DIVIDER}`,
                      pr: 1,
                    }}
                  >
                    <ServiceTypeAvatar serviceType={serviceType} sx={{ width: 24, height: 24 }} />
                  </Box>
                  <Typography
                    sx={{
                      color: 'text.secondary',
                      display: 'block',
                    }}
                    variant="body1"
                  >
                    {recurrenceText}
                  </Typography>
                </Box>
              </Box>
            </ListItem>
          </React.Fragment>
        )
      })}
    </List>
  )
}

ServicesList.propTypes = {
  services: PropTypes.array.isRequired,
}

export default ServicesList
